import { render, staticRenderFns } from "./MyResourcePermissions.vue?vue&type=template&id=fc971070&scoped=true&"
import script from "./MyResourcePermissions.vue?vue&type=script&lang=js&"
export * from "./MyResourcePermissions.vue?vue&type=script&lang=js&"
import style0 from "./MyResourcePermissions.vue?vue&type=style&index=0&id=fc971070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc971070",
  null
  
)

export default component.exports